import React from 'react';
import PropTypes from 'prop-types';
import I18n from 'utils/I18n';
import { useActivityPublicContext } from '../../ActivityPublicContext';

import styles from './styles.scss';

export function photoSrc(photo) {
  return photo.urls && photo.urls[Object.keys(photo.urls)[0]];
}

export default function Photos({ photos }) {
  const {
    openSignUpModal,
    showSignUpModal,
    track
  } = useActivityPublicContext();

  if (photos.length === 0) {
    return null;
  }

  const trackPhotoClick = () => track({ element: 'photo', action: 'click' });

  const maxPhotos = 4;
  const displayPhotos = photos.slice(0, maxPhotos);
  const overflowCount = photos.length - maxPhotos + 1;

  const PhotoElement = ({ children, ...props }) => {
    const PhotoElementWrapper = showSignUpModal ? 'button' : 'div';

    return (
      <PhotoElementWrapper
        onClick={() => {
          trackPhotoClick();
          if (showSignUpModal) {
            openSignUpModal('generic');
          }
        }}
        data-cy="photo"
        {...props}
      >
        {children}
      </PhotoElementWrapper>
    );
  };

  PhotoElement.propTypes = { children: PropTypes.node.isRequired };

  return (
    <div className={styles.container}>
      <h3>
        {I18n.t('strava.activities.show_public.photos_v2', {
          count: photos.length
        })}
      </h3>
      <ul className={styles.photosList}>
        {displayPhotos.map((photo) => (
          <li key={photo.unique_id}>
            <PhotoElement className={styles.photoWrapper}>
              <img src={photoSrc(photo)} alt={photo.caption} />
            </PhotoElement>
          </li>
        ))}

        {overflowCount > 1 && (
          <li className={styles.overflow}>
            <PhotoElement className={styles.overflowCount}>
              +{overflowCount}
            </PhotoElement>
          </li>
        )}
      </ul>
    </div>
  );
}

Photos.propTypes = {
  photos: PropTypes.arrayOf(PropTypes.object).isRequired
};
